module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "svi-socioeconomic--dataset-cover.b495c268.png";